// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__+Huz2","closed":"Logo_closed__ygdoc","hovered":"Logo_hovered__yMik5"};